interface RosterNeedsCountProps {
  count: number;
}

/** Compact "+N" chip when a client has curated prescription needs. */
export function RosterNeedsCount({ count }: RosterNeedsCountProps) {
  if (count <= 0) return null;

  return (
    <span
      className="inline-flex items-center rounded-full bg-muted px-1.5 py-0 text-[10px] font-semibold text-muted-foreground tabular-nums"
      title={`${count} prescription need${count === 1 ? '' : 's'} — select client to view`}
      data-testid="roster-needs-count"
    >
      +{count}
    </span>
  );
}
